import { Params } from '@angular/router';
import { RouterReducerState, getRouterSelectors } from '@ngrx/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectRouter = createFeatureSelector<RouterReducerState<any>>('router');

export const {
  selectCurrentRoute, // select the current route
  selectFragment, // select the current route fragment
  selectQueryParams, // select the current route query params
  selectQueryParam, // factory function to select a query param
  selectRouteParams, // select the current route params
  selectRouteParam, // factory function to select a route param
  selectRouteData, // select the current route data
  selectRouteDataParam, // factory function to select a route data param
  selectUrl, // select the current url
  selectTitle, // select the title if available
} = getRouterSelectors();

export const selectRouteNestedParams = createSelector(selectRouter, (router: any) =>
  extractParams(router?.state?.root),
);

const extractParams = (route: any): Params => {
  let innerParams: Params = { ...route.params };

  if (route && route.children.length) {
    route.children.forEach((childRoute: any) => {
      innerParams = {
        ...innerParams,
        ...extractParams(childRoute),
      };
    });
  }

  return innerParams;
};

export const selectRouteNestedParam = (param: string): any =>
  createSelector(selectRouteNestedParams, (params) => params && params[param]);
